import httpStore from "@/api/httpStore.js";

// ─── VEHICLES ───

export function getVehicles(params = {}) {
  return httpStore
    .get("vehicle_management/vehicles", { params })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function getVehicle(id) {
  return httpStore
    .get("vehicle_management/vehicle", { params: { id } })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function createVehicle(vehicleData) {
  return httpStore
    .post("vehicle_management/vehicle", vehicleData)
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function updateVehicle(vehicleData) {
  return httpStore
    .put("vehicle_management/vehicle", vehicleData)
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function deleteVehicle(id) {
  return httpStore
    .delete("vehicle_management/vehicle", { params: { id } })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function getVehicleDeleteInfo(id) {
  return httpStore
    .get("vehicle_management/vehicle_delete_info", { params: { id } })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

// ─── FAMILIES ───

export function getFamilies(params = {}) {
  return httpStore
    .get("vehicle_management/families", { params })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function createFamily(familyData) {
  return httpStore
    .post("vehicle_management/family", familyData)
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function updateFamily(familyData) {
  return httpStore
    .put("vehicle_management/family", familyData)
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function deleteFamily(catalogCode) {
  return httpStore
    .delete("vehicle_management/family", {
      params: { catalog_code: catalogCode }
    })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function getFamilyDeleteInfo(catalogCode) {
  return httpStore
    .get("vehicle_management/family_delete_info", {
      params: { catalog_code: catalogCode }
    })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

// ─── VEHICLE ↔ FAMILY RELATIONS ───

export function getFamilyVehicles(catalogCode) {
  return httpStore
    .get("vehicle_management/family_vehicles", {
      params: { catalog_code: catalogCode }
    })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function assignVehicle(vehicleId, catalogCode) {
  return httpStore
    .post("vehicle_management/assign_vehicle", {
      vehicle_id: vehicleId,
      catalog_code: catalogCode
    })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function unassignVehicle(vehicleId) {
  return httpStore
    .post("vehicle_management/unassign_vehicle", { vehicle_id: vehicleId })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function bulkAssign(vehicleIds, catalogCode) {
  return httpStore
    .post("vehicle_management/bulk_assign", {
      vehicle_ids: vehicleIds,
      catalog_code: catalogCode
    })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

export function bulkUnassign(vehicleIds) {
  return httpStore
    .post("vehicle_management/bulk_unassign", { vehicle_ids: vehicleIds })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

// ─── FAMILY IMAGE ───

export function saveFamilyImage(catalogCode, imageUrl) {
  return httpStore
    .post("vehicle_management/save_family_image", {
      catalog_code: catalogCode,
      image_url: imageUrl
    })
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}

// ─── STATS ───

export function getVehicleStats() {
  return httpStore
    .get("vehicle_management/stats")
    .then(res => res.data)
    .catch(e => {
      throw e;
    });
}
